import { useCallback, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import useToast from 'hooks/useToast'
import { useTranslation } from 'contexts/Localization'
import { useAppDispatch } from 'state'
import { fetchMultiPoolUserDataAsync } from 'state/multiPool'
import { stakeMultiPool } from 'utils/calls'
import { useMultiPoolContract } from 'hooks/useContract'

const useStakeMultiPool = () => {
  const dispatch = useAppDispatch()
  const { toastSuccess, toastError } = useToast()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [isStaking, setIsStaking] = useState(false)
  const multiPoolContract = useMultiPoolContract()

  const handleStakeMultiPool = useCallback(
    async (amount: string) => {
      try {
        setIsStaking(true)
        const status = await stakeMultiPool(multiPoolContract, amount)

        if (status) {
          toastSuccess(
            `${t('Staked')}!`,
            t('Your DMD has been staked in the pool!'),
          )
          dispatch(fetchMultiPoolUserDataAsync(account))
        } else {
          toastError(
            t('Error'),
            t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
          )
        }

        setIsStaking(false)
      } catch (e) {
        console.error(e)
        toastError(
          t('Error'),
          t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
        )
        setIsStaking(false)
      }
    },
    [dispatch, t, toastSuccess, toastError, account, multiPoolContract],
  )

  return { handleStakeMultiPool, isStaking }
}

export default useStakeMultiPool
